// src/pages/PrivacyPolicy.js
import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1 className='privacy-h1'>Privacy Policy</h1>
      
      <section className='privacy-section'>
        <h2 className='privacy-h2'>Introduction</h2>
        <p className='privacy-p'>Welcome to our website. This Privacy Policy outlines how we collect, use, and protect your information. By using our website, you agree to the collection and use of information in accordance with this policy.</p>
      </section>
      
      <section className='privacy-section'>
        <h2 className='privacy-h2'>Information Collection and Use</h2>
        <p className='privacy-p'>We collect personal information such as your name, email, and other information that you provide when you register or log into our website. This information is used solely to improve user experience and provide you with services such as communication and support.</p>
      </section>
      
      <section className='privacy-section'>
        <h2 className='privacy-h2'>Data Protection</h2>
        <p>We take appropriate security measures to protect your personal information. However, please note that no method of transmission over the internet is 100% secure.</p>
      </section>
      
      <section className='privacy-section'>
        <h2 className='privacy-h2'>Third-Party Services</h2>
        <p className='privacy-p'>We may use third-party services to improve the website or provide additional functionality. These services may collect data independently, and you should review their privacy policies.</p>
      </section>

      {/* GDPR Rights Section */}
      <section className='privacy-section'>
        <h2 className='privacy-h2'>Your Rights Under GDPR</h2>
        <p className='privacy-p'>As a user of our website, and in accordance with the General Data Protection Regulation (GDPR), you have the following rights concerning your personal data:</p>
        
        <h3 className='privacy-h3'>Right to Access</h3>
        <p className='privacy-p'>You have the right to request access to the personal data we hold about you at any time. This allows you to know what personal data we are processing, why we are processing it, and how long we intend to keep it.</p>
        
        <h3 className='privacy-h3'>Right to Rectification</h3>
        <p className='privacy-p'>You have the right to request corrections or updates to any personal data we hold about you that is inaccurate or incomplete. If you believe any of the information we hold is incorrect, you can ask us to correct or complete it.</p>
        
        <h3 className='privacy-h3'>Right to Erasure (Right to be Forgotten)</h3>
        <p className='privacy-p'>You have the right to request the deletion of your personal data from our records. This is also known as the right to be forgotten. We will erase your personal data when it is no longer needed for the purposes for which it was collected or if you withdraw your consent.</p>
        
        <h3 className='privacy-h3'>Right to Restriction of Processing</h3>
        <p className='privacy-p'>You have the right to request that we limit the processing of your personal data under certain circumstances, such as when you contest the accuracy of your data or when you object to our processing of your data.</p>
        
        <h3 className='privacy-h3'>Right to Data Portability</h3>
        <p className='privacy-p'>You have the right to request a copy of your personal data in a structured, commonly used, and machine-readable format. You can also ask us to transfer your personal data to another organization, where technically feasible.</p>
        
        <h3 className='privacy-h3'>Right to Object</h3>
        <p className='privacy-p'>You have the right to object to our processing of your personal data for certain reasons, including direct marketing.</p>
      </section>

      <section className='privacy-section'>
        <h2 className='privacy-h2'>Changes to This Privacy Policy</h2>
        <p className='privacy-p'>We may update our Privacy Policy from time to time. Any changes will be posted on this page, and we encourage you to review it periodically.</p>
      </section>
      
      <section className='privacy-section'>
        <h2 className='privacy-h2'>Contact Us</h2>
        <p className='privacy-p'>If you have any questions about this Privacy Policy, please contact us at <a className="privacy-a" href="mailto:hello@morphologic-competitions.com">hello@morphologic-competitions.com</a>.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
